import { useState } from 'react';
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogContentText, Typography, makeStyles } from '@material-ui/core';
import { useDeleteCompany } from 'common/hooks/company/useDeleteCompany';
import { useNotifier } from 'common/hooks/useNotifier';
import Message from 'common/models/Message';

const styles = {
    btnCancel: {
        border: '1px solid #2b333f',
        color: '#2b333f',
        '&:active': {
            backgroundColor: '1px solid #2b333f',
            boxShadow: 'none',
        },
        '&:hover': {
            backgroundColor: '1px solid #2b333f',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '1px solid #2b333f',
            boxShadow: 'none',
        },
        '&:disabled': {
            backgroundColor: '#eee !important',
            color: '#ccc !important',
        },
    },
    btnConfirm: {
        marginLeft: '5px',
    },
};

const useStyles = makeStyles(styles);

interface IDeleteCompanyDialog {
    open: boolean;
    id: number;
    name: string;
    close: () => void;
}

export const DeleteCompanyDialog = ({ open, id, name, close }: IDeleteCompanyDialog) => {
    const classes = useStyles();
    const { deleteCompany } = useDeleteCompany();
    const [isDeleting, setIsDeleting] = useState(false);
    const { notify } = useNotifier();

    const handleDelete = async () => {
        setIsDeleting(true);

        try {
            await deleteCompany({ id });
            close();
        } catch (error) {
            console.error(error);
            notify(new Message({ title: `Unable to delete company. ${error}`, type: 'error' }));
        }

        setIsDeleting(false);
    };

    return (
        <Dialog open={open} aria-labelledby="form-dialog-title">
            <DialogContent>
                <DialogContentText color="primary">
                    <Box p={1} style={{ width: '25vw' }}>
                        <Typography variant="h6">Delete Company</Typography>
                        <Box p={1}></Box>
                        <Typography>Are you sure you want to delete company {name}?</Typography>
                        <Box p={1}></Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', p: 1, m: 1, justifyContent: 'flex-end' }}>
                            <Button
                                variant="outlined"
                                size="medium"
                                color="secondary"
                                onClick={() => {
                                    close();
                                }}
                                disabled={isDeleting}
                                className={classes.btnCancel}
                            >
                                Cancel
                            </Button>
                            <Button
                                autoFocus
                                variant="contained"
                                size="medium"
                                onClick={handleDelete}
                                disabled={isDeleting}
                                className={classes.btnConfirm}
                            >
                                Delete
                                {isDeleting ? (
                                    <>
                                        <Box sx={{ ml: 1, mr: 1 }}>
                                            <CircularProgress size={'0.8rem'} color="inherit" />
                                        </Box>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </Button>
                        </Box>
                    </Box>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};
